import dayjs from 'dayjs';
import * as React from 'react';
import * as Redux from 'react-redux';
import { dateformat } from '../../../helpers';
import { PARAMS_RESERVAS } from '../../../store/Types';
import { getAllAreasAction } from '../../areas/AreasAction';

const ReservasRestauranteHook = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const reservasRestauranteStore = Redux.useSelector(
    (state) => state.reservasRestaurante
  );

  const [openModalForm, setOpenModalForm] = React.useState(false);
  const [openModalDetalles, setOpenModalDetalles] = React.useState(false);
  const [isDetalles, setIsDetalles] = React.useState(false);

  const [date, setDate] = React.useState(
    dayjs(dateformat(null, { full: true })).toDate()
  );
  const [dateTo, setDateTo] = React.useState(
    dayjs(dateformat(null, { full: true }))
      .add(30, 'd')
      .toDate()
  );

  const utcOffset = entidadesStore.activo.country.utcOffset || 'UTC-04:00';

  React.useEffect(() => {
    const fetchData = async () => {
      const { data: areas } = await getAllAreasAction(dispatch, {
        entityId: entidadesStore.activo.id,
      });
      const payload = {
        ...reservasRestauranteStore.params,
        entityId: entidadesStore.activo.id,
        date: dayjs(date).utcOffset(utcOffset).toDate(),
        dateTo: dayjs(dateTo).utcOffset(utcOffset).toDate(),
        areaId: areas[0]?.id || null,
        userId: null,
        codeId: null,
      };

      dispatch({
        type: PARAMS_RESERVAS,
        payload,
      });
    };
    fetchData();
  }, []);

  React.useEffect(() => {
    if (reservasRestauranteStore.activo) {
      setOpenModalDetalles(true);
    }
  }, [reservasRestauranteStore.activo]);

  return {
    openModalForm,
    setOpenModalForm,
    openModalDetalles,
    setOpenModalDetalles,
    utcOffset,
    date,
    setDate,
    dateTo,
    setDateTo,
    isDetalles,
    setIsDetalles,
  };
};

export default ReservasRestauranteHook;
